import type { Editor } from '@tiptap/react';
import type { Node as ProseMirrorNode } from '@tiptap/pm/model';

export type HeaderFooterZone = 'header' | 'footer';

export interface OpenHeaderFooter {
  editor: Editor;
  zone: HeaderFooterZone;
  pageNumber: number;
}

export const ZONE_LABELS: Record<HeaderFooterZone, { label: string; firstPageLabel: string }> = {
  header: { label: 'Header', firstPageLabel: 'First page header' },
  footer: { label: 'Footer', firstPageLabel: 'First page footer' },
};

export const readOpenHeaderFooter = (bodyEditor: Editor | null): OpenHeaderFooter | null => {
  const storage = bodyEditor?.storage.pages;
  const zone = storage?.activeEditorType;
  if ((zone !== 'header' && zone !== 'footer') || !storage?.activeEditor) return null;
  return { editor: storage.activeEditor, zone, pageNumber: storage.activePageNumber ?? 1 };
};

export const openHeaderFooterKey = (open: OpenHeaderFooter | null): string | null =>
  open ? `${open.zone}:${open.pageNumber}` : null;

export const openZoneEditor = (bodyEditor: Editor, zone: HeaderFooterZone, pageNumber: number): void => {
  if (zone === 'header') bodyEditor.commands.openHeaderEditor({ pageNumber });
  else bodyEditor.commands.openFooterEditor({ pageNumber });
};

export const closeZoneEditor = (bodyEditor: Editor, zone: HeaderFooterZone): void => {
  if (zone === 'header') bodyEditor.commands.closeHeaderEditor();
  else bodyEditor.commands.closeFooterEditor();
};

export const isZoneCell = (node: ProseMirrorNode): boolean => {
  const role = node.type.spec.tableRole;
  return role === 'cell' || role === 'header_cell';
};
